import React from 'react';
import api from 'api';
import { Spinner, Multilingual, TextInput, LongTextInput, CheckBox } from 'hyperdb-utils';
import PdfInput from '../components/PdfInput';

const MultilingualLongTextInput = Multilingual(LongTextInput);
const MultilingualTextInput = Multilingual(TextInput);
const MultilingualPdfEditor = Multilingual(PdfInput);

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
  }
  componentDidMount() {
    const propertyId = this.props.propertyId;
    if (!this.props.id) {
      const objectData = {
        id: 0,
        property: { $type: 'reference', external: true, value: ['properties', propertyId] },
      };
      this.props.api.emailPropertyData.submitCreateForm(objectData)
        .then(() => {
          if (this.props.savedObject) {
            const id = this.props.savedObject.id;
            this.props.api.emailPropertyData.initEditForm(id);
            this.props.api.property.updateEditedObject({
              attributeName: 'email_data',
              value: { $type: 'reference', external: true, value: ['email_property_datas', id] },
            });
          }
        });
    } else {
      this.props.api.emailPropertyData.initEditForm(this.props.id);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadSuccess) {
      this.props.api.emailPropertyData.setData({ uploadSuccess: false });
    }
  }
  render() {
    if (!this.props.objectData) return <Spinner show={ this.props.show } />;
    const propertyData = this.props.objectData || {};
    const availableLocales = this.props.availableLanguages;
    return (
      <div style={ {display: this.props.show ? 'block' : 'none'} }>
        <fieldset>
          <MultilingualLongTextInput
            label="Property presentation"
            name="presentation"
            value={ this.localizedValue('presentation') }
            onChange={ this.handleChangeLocalized.bind(this, 'presentation') }
            availableLocales={ availableLocales }
          />
          <MultilingualTextInput
            label="Information on balance"
            name="balance_information"
            value={ this.localizedValue('balance_information') }
            onChange={ this.handleChangeLocalized.bind(this, 'balance_information') }
            availableLocales={ availableLocales }
          />
          <MultilingualLongTextInput
            label="Practical information on stay"
            name="practical_information"
            value={ this.localizedValue('practical_information') }
            onChange={ this.handleChangeLocalized.bind(this, 'practical_information') }
            availableLocales={ availableLocales }
          />
          <CheckBox
            label="Use practical information for pdf"
            name="use_practical_information_for_pdf"
            checked={ propertyData.use_practical_information_for_pdf }
            onChange={ this.handleClickCheckbox.bind(this, 'use_practical_information_for_pdf') }
          /><br/>
          {
            propertyData.id
              ? <div>
                  <MultilingualPdfEditor
                    label="Information pdf"
                    name="information_pdf"
                    value={ this.localizedValue('information_pdf') }
                    onChange={ this.handleChangeLocalized.bind(this, 'information_pdf') }
                    availableLocales={ availableLocales }
                  />
                </div>
              : null
          }
        </fieldset>
      </div>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.emailPropertyData.updateEditedObject({ attributeName, value })
      .then(() => this.props.onChange());
  }
  handleClickCheckbox(attributeName, field) {
    const propertyData = this.props.objectData || {};
    const checked = !propertyData[attributeName];
    this.handleChange(attributeName, { value: checked });
  }
  handleChangeLocalized(attributeName, field) {
    const { name, value } = field;
    this.handleChange(attributeName, { value: { $i18n: value } });
  }
  localizedValue(attributeName) {
    return (this.props.objectData[attributeName] || {}).$i18n;
  }
}

export default api.connect(Form, 'emailPropertyData');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/property-data/containers/Form.jsx